import {helpers} from 'vuelidate/lib/validators';
import EMOJI_REGEX from 'emojibase-regex';
import {dateFormat, MIN_DATE} from '@/utils/services';
import {UploadDocumentMainGroups, UploadDocumentTypes} from "@/utils/uploadDocumentTypes";
import { isNoticeRecoveryClassifierEnable } from '@/app.config';

export function getValidationErrorText(vPath: any) {
  if (!vPath) {
    return;
  }
  let errors: string[] = [];
  if (vPath.$error && !vPath.TRAILING_AND_LEADING_SPACES && vPath.$params.TRAILING_AND_LEADING_SPACES) {
    errors.push('Удалите лишние пробелы')
  }
  if (vPath.$error && !vPath.HAS_ANNOUNCEMENT_RULE && vPath.$params.HAS_ANNOUNCEMENT_RULE) {
    errors.push('Необходимо указать в заявлении отсутствие спора в суде');
  }
  if (vPath.$error && !vPath.required && vPath.$params.required) {
    errors.push('Поле обязательно для заполнения');
  }
  if (vPath.$error && !vPath.numeric && vPath.$params.numeric) {
    errors.push('Можно вводить только цифры');
  }
  if (vPath.$error && !vPath.decimal && vPath.$params.decimal) {
    errors.push('Можно вводить только цифры');
  }
  if (vPath.$error && !vPath.maxLength && vPath.$params.maxLength) {
    errors.push(
      `Максимальная длина поля ${vPath.$params.maxLength.max} символов`
    );
  }
  if (
    vPath.$error &&
    !vPath.CURRENCY_MAX_LENGTH &&
    vPath.$params.CURRENCY_MAX_LENGTH
  ) {
    errors.push(
      `Максимальная длина поля ${vPath.$params.CURRENCY_MAX_LENGTH.value} символов`
    );
  }
  if (
    vPath.$error &&
    !vPath.DOCS_REQUIREMENTS &&
    vPath.$model &&
    vPath.$model.length &&
    vPath.$params.DOCS_REQUIREMENTS
  ) {

    errors = [
      ...errors,
      ...getDocsValidationTexts(vPath.$model)
    ]
  }
  if (vPath.$error && !vPath.REQUIRED_DOC && vPath.$params.REQUIRED_DOC) {
    let docName: string = ''
    UploadDocumentTypes.forEach(group => {
      group.documents.forEach(doc => {
        if (doc.value === vPath.$params.REQUIRED_DOC.reqCode) {
          docName = doc.name.charAt(0).toUpperCase() + doc.name.slice(1)
        }
      })
    })
    errors.push(
      `Должен быть загружен документ "${docName}"`
    );
  }
  if (vPath.$error && !vPath.minLength && vPath.$params.minLength) {
    errors.push(
      `Минимальная длина поля ${vPath.$params.minLength.min} символов`
    );
  }
  if (vPath.$error && !vPath.minValue && vPath.$params.minValue) {
    errors.push(`Минимальное значение поля ${vPath.$params.minValue.min}`);
  }
  if (
    vPath.$error &&
    !vPath.DOCUMENTS_MIN_LENGTH &&
    vPath.$params.DOCUMENTS_MIN_LENGTH
  ) {
    errors.push('Должен быть загружен хотя бы один документ');
  }
  if (vPath.$error && !vPath.FILE_TYPE && vPath.$params.FILE_TYPE) {
    errors.push(
      `Некорректный формат, файл должен иметь расширение ${vPath.$params.FILE_TYPE.value}`
    );
  }
  if (vPath.$error && !vPath.FILE_SIZE && vPath.$params.FILE_SIZE) {
    errors.push(
      `Превышен максимально допустимый размер файла ${vPath.$params.FILE_SIZE.value} Мбайт`
    );
  }
  if (
    vPath.$error &&
    !vPath.FILE_NAME_MAX_LENGTH &&
    vPath.$params.FILE_NAME_MAX_LENGTH
  ) {
    errors.push(
      `Длина имени файла должна быть меньше ${vPath.$params.FILE_NAME_MAX_LENGTH.value} символов`
    );
  }
  if (vPath.$error && !vPath.FILE_SIG_NAME && vPath.$params.FILE_SIG_NAME) {
    errors.push(
      'Наименование файла подписи должно соответствовать наименованию файла'
    );
  }
  if (
    vPath.$error &&
    !vPath.CURRENCY_ONLY_POSITIVE &&
    vPath.$params.CURRENCY_ONLY_POSITIVE
  ) {
    errors.push('Можно вводить только положительные числа');
  }
  if (vPath.$error && !vPath.DATA_MATCH && vPath.$params.DATA_MATCH) {
    errors.push(`Совпадение данных: ${vPath.$params.DATA_MATCH.entities}`);
  }
  if (vPath.$error && !vPath.DATE && vPath.$params.DATE) {
    errors.push('Неправильно введена дата');
  }
  if (vPath.$error && !vPath.IS_TWO_YEARS_SINCE_DATE && vPath.$params.IS_TWO_YEARS_SINCE_DATE) {
    errors.push(
      'Со дня, когда обязательство должно было быть исполнено, прошло более чем два года.'
    );
  }
  if (vPath.$error && !vPath.CHECK_DATE_PENALTY_LIM_FROM && vPath.$params.CHECK_DATE_PENALTY_LIM_FROM) {
    errors.push(
      'Не может быть меньше или равна дате когда обязательство должно быть исполнено'
    );
  }
  if (vPath.$error && !vPath.MIN_PERIOD_DATE && vPath.$params.MIN_PERIOD_DATE) {
    errors.push(
      'Дата начала периода должна быть меньше даты окончания периода'
    );
  }

  if (!vPath.url && vPath.$params.url) {
    errors.push(
      `Адрес должен начинаться с http://, https:// или ftp:// и содержать указание домена (.com, .рф). Пример формата адреса: «http://пример.example.com/hp, «https://пример.example.com/hp, ftp://пример.example.com/hp»`
    );
  }

  if (
    (!vPath.EMAIL && vPath.$params.EMAIL) ||
    (!vPath.email && vPath.$params.email) ||
    (!vPath.EMOJI && vPath.$params.EMOJI) ||
    (!vPath.INN && vPath.$params.INN) ||
    (!vPath.SNILS && vPath.$params.SNILS) ||
    (!vPath.OGRN && vPath.$params.OGRN) ||
    (!vPath.KPP && vPath.$params.KPP) ||
    (!vPath.INN_FOREIGN_ORGANIZATION_ROD &&
      vPath.$params.INN_FOREIGN_ORGANIZATION_ROD) ||
    (!vPath.STORAGE_FILE_IDS && vPath.$params.STORAGE_FILE_IDS) ||
    (!vPath.CYRILLIC_NUMBER_SYMBOL && vPath.$params.CYRILLIC_NUMBER_SYMBOL) ||
    (!vPath.DATE_CORRECT_PERIOD && vPath.$params.DATE_CORRECT_PERIOD) ||
    (!vPath.DATE_MAX_100 && vPath.$params.DATE_MAX_100) ||
    (!vPath.PERSON_NAME && vPath.$params.PERSON_NAME)
  ) {
    errors.push(`Некорректный формат`);
  }

  if (!vPath.IS_NOT_EQUAL && vPath.$params.IS_NOT_EQUAL) {
    errors.push(`Номер счета и номер корреспондентского счета заявителя не должны совпадать.`);
  }

  if (vPath.$error && !vPath.ACCOUNT_NUMBER_NO_REPEATING && vPath.$params.ACCOUNT_NUMBER_NO_REPEATING) {
    errors.push(`Номер счета ${vPath.$params.ACCOUNT_NUMBER_NO_REPEATING.value} имеет неверный формат. Счет должен состоять из 20 цифр и не может быть заполнен нулями или повторяющимися цифрами.`);
  }

  if (vPath.$error && !vPath.ORG_ACCOUNT_NUMBER && vPath.$params.ORG_ACCOUNT_NUMBER) {
    errors.push(`Указанный номер счета ${vPath.$params.ORG_ACCOUNT_NUMBER.value} не является счетом юридического лица. Укажите счет юридического лица.`);
  }

  if (vPath.$error && !vPath.ACCOUNT_NUMBER_CHECKSUM && vPath.$params.ACCOUNT_NUMBER_CHECKSUM) {
    errors.push(`Номер счета ${vPath.$params.ACCOUNT_NUMBER_CHECKSUM.value} недействителен. Не пройдена проверка на контрольный ключ.`);
  }

  if (
    vPath.$error &&
    !vPath.DOCS_GROUPS_REQUIRED &&
    vPath.$params.DOCS_GROUPS_REQUIRED
  ) {
    errors = [
      ...errors,
      ...getDocGroupsValidationTexts(vPath.$model, vPath.$params.DOCS_GROUPS_REQUIRED.groups)
    ]
  }

  return errors;
}

export const MAX_LENGTH = 60;
export const MAX_LENGTH_EMAIL = 60;

export const MinLength = {
  SNILS: 14,
  BIC: 9,
  PHONE: 16,
  OGRNIP: 15,
};

export const TRAILING_AND_LEADING_SPACES = helpers.withParams(
  {type: 'TRAILING_AND_LEADING_SPACES'},
  (value: any) => !helpers.req(value) || String(value).trim() === String(value)
)

// email не учитываем регистр домена
// eslint-disable-next-line
const emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-z0-9](?:[A-z0-9-]*[A-z0-9])?\.)+[A-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)])$/;
export const EMAIL = helpers.withParams(
  {type: 'EMAIL'},
  (value: any) => !helpers.req(value) || emailRegex.test(value)
);

export const PERSON_NAME = helpers.regex(
  'PERSON_NAME',
  /^([А-ЯЁ][а-яё.]*)+([ -]([А-ЯЁа-яё][а-яё.]*)+)*$/
);

export const CYRILLIC_NUMBER_SYMBOL = helpers.regex(
  'CYRILLIC_NUMBER_SYMBOL',
  /^[А-ЯЁ\-\sа-яё0-9!#$%&'"@()№;:*+/=?^_`{|}~-]*$/
);

// const emojiRegex = new RegExp('^[\u{203C}]*$', 'u');
export const EMOJI = helpers.withParams({type: 'EMOJI'}, (value: any) => {
  return !helpers.req(value) || (value && !value.match(EMOJI_REGEX));
});

export const STORAGE_FILE_IDS = helpers.withParams(
  {type: 'STORAGE_FILE_IDS'},
  (value: any) => {
    return !helpers.req(value) || (value && value.length === 39);
  }
);

export const FILE_TYPE = (typeArr: string[]) =>
  helpers.withParams({type: 'FILE_TYPE', value: typeArr}, (file: any) => {
    if (!file || file.sigBas64) return true;

    const fileName = file.name.toLowerCase();

    return (
      !helpers.req(file) ||
      typeArr.some((el: string) => fileName.endsWith(el.toLowerCase()))
    );
  });

export const FILE_SIZE = (sizeInMB: number) =>
  helpers.withParams({type: 'FILE_SIZE', value: sizeInMB}, (file: any) => {
    if (!file || file.sigBas64) return true;
    return !helpers.req(file) || file.size <= sizeInMB * 1024 * 1024;
  });

export const FILE_NAME_MAX_LENGTH = (length: number) =>
  helpers.withParams(
    {type: 'FILE_NAME_MAX_LENGTH', value: length},
    (file: any) => {
      if (!file || file.sigBas64) return true;

      const fileNameArray = file.name.split('.');
      fileNameArray.pop();
      const fileName = fileNameArray.join('.');

      return fileName.length < length;
    }
  );

export const FILE_SIG_NAME = (fileOriginal: File, disabled?: boolean) =>
  helpers.withParams({type: 'FILE_SIG_NAME'}, (file: any) => {
    if (disabled || !file || file.sigBas64) {
      return true;
    }

    const fileNameArray = file.name.split('.');
    fileNameArray.pop();
    const fileName = fileNameArray.join('.');

    return fileName === fileOriginal.name;
  });

export const CURRENCY_ONLY_POSITIVE = helpers.withParams(
  {type: 'CURRENCY_ONLY_POSITIVE'},
  (value: string) => !helpers.req(value) || (value || 0) >= 0
);

// По схеме для полей 6шаг ИН допускается максимум 15 символов.
// vue-currency-input добавляет пробелы для десятков и "," для дробной части = 5 символов
export const CURRENCY_MAX_LENGTH = helpers.withParams(
  {type: 'CURRENCY_MAX_LENGTH', value: 15},
  (value: number | string) => {
    return (
      !helpers.req(value) ||
      (typeof value === 'string' && helpers.len(value) <= 15) ||
      (typeof value === 'number' && helpers.len(String(value)) <= 15)
    );
  }
);

// дата не может быть меньше или равна дате взыскания(не учитывается при переотправке в ФССП)
export const checkDatePenaltyLimFrom = (isResendToFsspStatement: boolean, timeLimitDate: string) => helpers.withParams(
  {type: 'CHECK_DATE_PENALTY_LIM_FROM', timeLimitDate},
  (value: string) => {
    if (!value || isResendToFsspStatement) return true;
    const selectedDate = new Date(dateFormat(value));
    const debtCollectionDate = new Date(dateFormat(timeLimitDate));

    return selectedDate.getTime() > debtCollectionDate.getTime();
  }
);

export const isDateBeforeOrEquals = (compareToDate: string) => helpers.withParams(
  {type: 'IS_DATE_BEFORE_OR_EQUALS', compareToDate},
  (value: string) => {
    if (!value) return true;
    return new Date(dateFormat(value)).getTime() >= new Date(dateFormat(compareToDate)).getTime();
  }
);

export const DATA_MATCH = (testValue: string, entities: string) =>
  helpers.withParams(
    {type: 'DATA_MATCH', entities},
    (inputValue: string) => !helpers.req(inputValue) || testValue !== inputValue
  );

// Со дня, когда обязательство должно было быть исполнено, прошло более чем два года.(не учитывается при переотправке в ФССП)
export const IS_TWO_YEARS_SINCE_DATE = (isResendToFsspStatement: boolean) => helpers.withParams(
  {type: 'IS_TWO_YEARS_SINCE_DATE'},
  (value: string) => {
    if (!value || isResendToFsspStatement) return true;
    Date.parse(value);
    const selectedDate = new Date(dateFormat(value));
    selectedDate.setFullYear(selectedDate.getFullYear() + 2);

    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    return selectedDate.getTime() >= currentDate.getTime();
  }
);

export const DATE_FORMAT = helpers.regex('DATE_FORMAT', /\d\d\.\d\d\.\d\d\d\d/);
export const DATE_PAST = helpers.withParams(
  {type: 'DATE_PAST'},
  (value: string) =>
    !helpers.req(value) || Date.parse(dateFormat(value)) >= Date.parse(MIN_DATE)
);
export const DATE_FUTURE = helpers.withParams(
  {type: 'DATE_FUTURE'},
  (value: string) =>
    !helpers.req(value) || Date.parse(dateFormat(value)) <= Date.now()
);

// Сравнение 2-х дат, первая должна быть меньше второй
// valueFrom - дата ОТ
// valueTo - дата ДО
export const DATE_CORRECT_PERIOD = (valueFrom: string, valueTo: string) =>
  helpers.withParams(
    {type: 'DATE_CORRECT_PERIOD', valueTo},
    () =>
      !helpers.req(valueFrom) ||
      !helpers.req(valueTo) ||
      Date.parse(dateFormat(valueFrom)) <= Date.parse(dateFormat(valueTo))
  );

// Проверка что дата не больше 100 лет от сегодняшней
// value - дата которую нужно проверить
export const DATE_MAX_100 = helpers.withParams(
  {type: 'DATE_MAX_100'},
  (value: string) => {
    const now = new Date();
    now.setFullYear(now.getFullYear() + 100);
    return !helpers.req(value) || Date.parse(dateFormat(value)) <= +now;
  }
);

export const REQUIRED_BOOLEAN = helpers.withParams(
  {
    type: 'REQUIRED_BOOLEAN',
  },
  (value: boolean) => value
);

export const HAS_ANNOUNCEMENT_RULE = helpers.withParams(
  {
    type: 'HAS_ANNOUNCEMENT_RULE'
  },
  (value: boolean) => value)

export const INN = (length: number) =>
  helpers.regex(
    'INN',
    new RegExp(`([0-9][1-9]|[1-9][0-9])[0-9]{${length - 2}}`)
  );

export const INN_ROD = helpers.withParams(
  {type: 'INN'},
  (value: string) => !helpers.req(value) || checkInnRod(value)
);

const checkDigitInnRod = function (inn: string, coefficients: number[]) {
  let n = 0;

  for (const i in coefficients) {
    n += coefficients[i] * Number(inn[i]);
  }

  return (n % 11) % 10;
};

// http://www.kholenkov.ru/data-validation/inn/
const checkInnRod = (inn: string) => {
  switch (inn.length) {
    case 10: {
      if (inn === '0000000000') return false;

      const n10 = checkDigitInnRod(inn, [2, 4, 10, 3, 5, 9, 4, 6, 8]);

      if (n10 === parseInt(inn[9])) return true;

      break;
    }
    case 12: {
      if (inn === '000000000000') return false;

      const n11 = checkDigitInnRod(inn, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
      const n12 = checkDigitInnRod(inn, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);

      if (n11 === parseInt(inn[10]) && n12 === parseInt(inn[11])) return true;
    }
  }

  return false;
};

export const SNILS_ROD = helpers.withParams(
  {type: 'SNILS'},
  (value: string) => !helpers.req(value) || checkSnilsRod(value)
);

// http://www.kholenkov.ru/data-validation/snils/
const checkSnilsRod = (snils: string) => {
  const rawSnils = snils.replaceAll('-', '').replaceAll(' ', '');
  let sum = 0;

  for (let i = 0; i < 9; i++) {
    sum += parseInt(rawSnils[i]) * (9 - i);
  }

  let checkDigit = 0;

  if (sum < 100) {
    checkDigit = sum;
  } else if (sum > 101) {
    checkDigit = sum % 101;

    if (checkDigit === 100) {
      checkDigit = 0;
    }
  }

  return checkDigit === parseInt(rawSnils.slice(-2));
};

export const KPP = helpers.regex(
  'KPP',
  /([0-9][1-9]|[1-9][0-9])[0-9]{2}[0-9A-Z]{2}[0-9]{3}/
);

export const INN_FOREIGN_ORGANIZATION_ROD = helpers.regex(
  'INN_FOREIGN_ORGANIZATION_ROD',
  new RegExp('9909[0-9]{6}')
);

// http://www.kholenkov.ru/data-validation/ogrn/
const checkOgrn = (ogrn: string) => {
  const n13 = parseInt((parseInt(ogrn.slice(0, -1)) % 11).toString().slice(-1));

  return n13 === parseInt(ogrn[12]);
};

export const OGRN = helpers.withParams(
  {type: 'OGRN'},
  (value: string) => !helpers.req(value) || checkOgrn(value)
);

export const ACCOUNT_NUMBER_NO_REPEATING = (value: string) => helpers.withParams(
  {type: 'ACCOUNT_NUMBER_MIN_LENGTH', value},
  () => {
    for (let i = 0; i < value.length; i++) {
      if (value[0] !== value[i]) return true
    }
    return false
  }
)

export const ORG_ACCOUNT_NUMBER = (value: string) => helpers.withParams(
  {type: 'ORG_ACCOUNT_NUMBER', value},
  () => {
    return ['474', '407', '603', '302', '454', '452', '301', '458', '459', '409', '706']
      .some(testVal => value.startsWith(testVal))
  }
)

const currencyDigitMap: Record<string, string> = {
  'A': '0',
  'B': '1',
  'C': '2',
  'E': '3',
  'H': '4',
  'K': '5',
  'M': '6',
  'P': '7',
  'T': '8',
  'X': '9',
}

const accountKeyValidationDigits = [7, 1, 3,  7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1];
function calculateControlDigit(digits: number[]) {
  const checkDigits = digits.map((val, pos) => (val * accountKeyValidationDigits[pos]) % 10);
  const sumDigit = checkDigits.reduce((prevSum, val) => prevSum + val, 0) % 10;
  const control = (sumDigit * 3) % 10;
  return control;
}

export const ACCOUNT_NUMBER_CHECKSUM = (value: string, bic: string, isCorAccount = false) => helpers.withParams(
  {type: 'ACCOUNT_NUMBER_CHECKSUM', value},
  () => {
    return true; 
    /*
    if (!value || !bic || bic.length < 9 || value.length !== 20) return false;
    const key = bic.substring(6, 9);
    const isRKC = ['000', '001', '002'].includes(key);
    const orgKey = (isRKC || isCorAccount) ? `0${bic.substring(4,6)}` : key;
    const accountLetters = value.split('');
    accountLetters[5] = currencyDigitMap[accountLetters[5].toUpperCase()] || accountLetters[5];
    const accountDigits =[...orgKey.split('').map(Number), ...accountLetters.map(Number)];
    return calculateControlDigit(accountDigits) === 0;
    */
  }
)

export const DOCS_REQUIREMENTS = (docs: []) => helpers.withParams(
  {type: 'DOCS_REQUIREMENTS'},
  () => {
    if (!isNoticeRecoveryClassifierEnable) return true
    return getDocsValidationTexts(docs).length === 0
  }
)

export const REQUIRED_DOC = (docs: [], reqCode: string) => helpers.withParams(
  {type: 'REQUIRED_DOC', docs: docs, reqCode: reqCode},
  () => {
    if (!isNoticeRecoveryClassifierEnable) return true
    return docs.filter((item: any) => item.description === reqCode).length > 0
  }
)

export const getDocsValidationTexts = (docs: any) => {
  const validationErrorMessages: any = []
  if (!docs && !docs.length) return []
  docs.forEach((doc: any) => {
    switch (doc.description) {
      case '10201':
        if (!docs.filter((item: any) => item.description === '10202').length) {
          validationErrorMessages.push('Должен быть загружен  документ “Индивидуальные условия к кредитному договору”')
        }
        break
      case '10202':
        if (!docs.filter((item: any) => item.description === '10201').length) {
          validationErrorMessages.push('Должен быть загружен  документ “Общие условия к кредитному договору”')
        }
        break
      case '10203':
      case '10204':
        if (!docs.filter((item: any) => item.description === '10202' || item.description === '10299').length) {
          validationErrorMessages.push('Должен быть загружен  документ “Индивидуальные условия к кредитному договору” или “Иной документ, выражающий содержание кредитного договора”')
        }
        break
      case '10302':
        if (!docs.filter((item: any) => item.description === '10303').length) {
          validationErrorMessages.push('Должен быть загружен  документ “Соглашение об уступке прав (переводе долга) по кредитному договору, кредитором по которым на основании уступки прав (требований) выступает единый институт развития в жилищной сфере”')
        }
        break
      case '10303':
        if (!docs.filter((item: any) => item.description === '10302').length) {
          validationErrorMessages.push('Должен быть загружен  документ “Кредитный договор, кредитором по которым на основании уступки прав (требований) выступает единый институт развития в жилищной сфере”')
        }
        break
      case '10402':
        if (!docs.filter((item: any) => item.description === '10401').length) {
          validationErrorMessages.push('Должен быть загружен  документ “Договор поручительства”')
        }
        break
      case '10502':
        if (!docs.filter((item: any) => item.description === '10501' || item.description === '10599').length) {
          validationErrorMessages.push('Должен быть загружен  документ “Договор об оказании услуг связи” или “Иные документы, выражающие содержание договора об оказания услуг связи')
        }
        break
      case '10602':
        if (!docs.filter((item: any) => item.description === '10603').length) {
          validationErrorMessages.push('Должен быть загружен  документ “Именная сохранная квитанция”')
        }
        break
      case '10603':
        if (!docs.filter((item: any) => item.description === '10602').length) {
          validationErrorMessages.push('Должен быть загружен  документ “Договор хранения”')
        }
        break
      case '10604':
        if (!docs.filter((item: any) => item.description === '10605').length) {
          validationErrorMessages.push('Должен быть загружен  документ “Документ, подтверждающий передачу арендодателем имущества арендатору”')
        }
        break
      case '10605':
        if (!docs.filter((item: any) => item.description === '10604').length) {
          validationErrorMessages.push('Должен быть загружен  документ “Договор проката”')
        }
        break
      case '11202':
        if (!docs.filter((item: any) => item.description === '11203').length) {
          validationErrorMessages.push('Должен быть загружен хотя бы один документ “Документ, подтверждающий направление уведомления о наличии задолженности”')
        }
        break
      case '11203':
        if (!docs.filter((item: any) => item.description === '11202').length) {
          validationErrorMessages.push('Должен быть загружен хотя бы один документ “Копия уведомления о наличии задолженности, направленного взыскателем должнику”')
        }
        break
    }
  })
  return validationErrorMessages
}

function createMapDocumentGroup2Codes() {
    const map: Record<string, string[]> = {};
    UploadDocumentTypes.forEach(item => {
        map[item.groupCode] = item.documents.map(doc => doc.value);
    });
    UploadDocumentMainGroups.forEach(item => {
       map[item.groupCode] = ([] as string[]).concat(...item.subgroups.map(sub => map[sub] ?? []));
    })    
    return map;
}

const MapDocumentGroupToCodes = createMapDocumentGroup2Codes();

function getDocGroupValidationText(group: string) {
  switch(group) {
    case '10000': return 'Должен быть загружен хотя бы один документ из группы "Документы, по которым взыскание задолженности производится в бесспорном порядке"';
    case '11200': return `Должен быть загружен хотя бы один документ из следующих:
 · копия уведомления о наличии задолженности, направленного взыскателем должнику, содержащее подтверждение направления такого уведомления (почтовый идентификатор);
 · копия уведомления о наличии задолженности, направленного взыскателем должнику;
 · документ, подтверждающий направление уведомления о наличии задолженности;
 · иные документы, связанные с уведомлением должника о наличии задолженности.`
  }
  return '';
}

const getDocGroupsValidationTexts = (docs: any[], groups: string[]) => {
  const absentGroups = groups.filter(group => {
    return !docs.some(doc => (MapDocumentGroupToCodes[group] ?? []).includes(doc.description))
  })
  return absentGroups.map(getDocGroupValidationText).filter(Boolean);
}

export const DOCS_GROUPS_REQUIRED = (docs: [], groups: string[]) => helpers.withParams(
  {type: 'DOCS_GROUPS_REQUIRED', groups},
  () => {
    if (!isNoticeRecoveryClassifierEnable) return true;
    return getDocGroupsValidationTexts(docs, groups).length === 0
  }
)
